const CURRENT_PRODUCT = null,
    CART_PRODUCTS = [],
    SELECTED_PRODUCTS = [];

function moneyFormatEssentialApps(e, t) {
    let r, i = Number.parseFloat(t).toFixed(2),
        a = window.Shopify?.shop;
    return a && ("jelt-2828.myshopify.com" === a || "maleia-studio.myshopify.com" === a) ? e.replace("{{amount_with_comma_separator}}", new Intl.NumberFormat("de-DE").format(Number.parseFloat(t).toFixed())) : (r = (r = (r = (r = (r = (r = e.replace("{{amount}}", Number.parseFloat(t).toFixed(2))).replace("{{amount_with_comma_separator}}", i.replace(".", ","))).replace("{{amount_with_dot_separator}}", i)).replace("{{amount_no_decimals}}", new Intl.NumberFormat("de-DE").format(Number.parseFloat(t).toFixed()))).replace("{{amount_no_decimals_with_comma_separator}}", new Intl.NumberFormat("de-DE").format(Number.parseFloat(t).toFixed()))).replace("{{amount_no_decimals_with_space_separator}}", new Intl.NumberFormat("hu-HU").format(Number.parseFloat(t).toFixed())), a && ("paulandmike-co.myshopify.com" === a || "cardinal-trading-retail.myshopify.com" === a || "grino-store.myshopify.com" === a) && (r = r.replace(".", ",")), a && "elemood.myshopify.com" === a && (r = t.toLocaleString("de-DE", {
        minimumFractionDigits: 2
    })), a && "mja-shoes.myshopify.com" === a && (r = `$${r=parseInt(t).toLocaleString("de-DE")}`), r)
}

function cardTitleEssentialApps(e, t = 0) {
    let r = moneyFormatEssentialApps("${{amount_no_decimals}}", e.goal - t);
    return t ? t > 0 && t < e.goal ? e.progressTitle.replace("{order-value-progress}", r) : t >= e.goal ? e.reachedTitle : void 0 : e.title.replace("{order-value}", r)
}

function updateTotalOnClick(e, t) {
    let r = document.querySelectorAll('form a, form button, form input[type="submit"]');
    if (r) {
        let i = () => {
            setTimeout(() => {
                pollCartTotalEssentialApps()
            }, 500), setTimeout(() => {
                pollCartTotalEssentialApps()
            }, 1e3)
        };
        "cart-page" === e.type && !t || window.freeShippingBarConfigs.clickEvents || window.freeShippingBarConfigs.observer || (r.forEach(e => {
            e.addEventListener("click", i, {
                passive: !0
            })
        }), document.addEventListener("booster:cart:update", () => {
            i()
        }), window.freeShippingBarConfigs.clickEvents = !0)
    }
}

function pollCartTotalEssentialApps() {
    if (window.freeShippingBarConfigs.threshold) return;
    window.freeShippingBarConfigs.threshold = !0, setTimeout(() => {
        window.freeShippingBarConfigs.threshold = !1
    }, 300);
    let e = window.Shopify.routes.root || "/";
    fetch(e + "cart.js").then(e => e.json()).then(e => {
        let t = e.total_price;
        e.items && e.items.length > 0 ? window.essentialOrderValueBoosterMeta.cartItems = e.items : window.essentialOrderValueBoosterMeta.cartItems = [], window.freeShippingBarConfigs && window.freeShippingBarConfigs.forEach(r => {
            let i = t;
            if (r.excludeProducts && r.excludeProducts.length > 0 && e.items.forEach(e => {
                    r.excludeProducts.find(t => t.handle === e.handle) && (i -= e.final_line_price)
                }), r.excludeProductTags && r.excludeProductTags.length > 0 && e.items.forEach(e => {
                    let t = CART_PRODUCTS;
                    if (CURRENT_PRODUCT) {
                        let a = t.find(e => e.id === CURRENT_PRODUCT.id);
                        a || t.push(CURRENT_PRODUCT)
                    }
                    let o = t.find(t => t.id === e.product_id),
                        n = o?.tags || [],
                        p = r.excludeProductTags.some(e => n.includes(e));
                    p && (i -= e.final_line_price)
                }), document.querySelector(`.free_shipping_card_wrapper_${r.id}`)) {
                let a = document.querySelectorAll(`.free_shipping_card_title_${r.id}`),
                    o = document.querySelectorAll(`.free_shipping_card_progress_bar_${r.id}`),
                    n = document.querySelectorAll(`.free_shipping_card_wrapper_${r.id}`);
                0 != a.length && a.forEach(e => {
                    e.textContent = cardTitleEssentialApps(r, i / 100)
                });
                let p = i / r.goal;
                p > 100 ? p = 100 : 0 === p && (p = 2.5), o.forEach(e => {
                    e.style.width = `${p}%`
                }), n.forEach(e => {
                    e.style.display = "flex"
                })
            }
            if (document.querySelector(`.free_shipping_bar_wrapper_${r.id}`)) {
                let s = document.querySelector(`.free_shipping_bar_title_${r.id}`),
                    l = document.querySelector(`.free_shipping_bar_wrapper_${r.id}`);
                s.textContent = cardTitleEssentialApps(r, i / 100), l.style.display = "flex"
            }
        });
        let r = window.location && window.location.pathname.endsWith("/cart");
        r && setTimeout(() => {
            window.freeShippingBarConfigs.clickEvents = !1, updateTotalOnClick({
                type: "not-cart-page"
            }, !0)
        }, 300)
    })
}

function essentialCloseFreeShippingBar(e, t) {
    let r = document.querySelector(`.free_shipping_bar_wrapper_${e}`);
    if (r) {
        r.parentNode.removeChild(r);
        try {
            window.localStorage.setItem("freeShippingBarClosed", JSON.stringify({
                value: !0,
                id: e,
                updatedAt: t
            }))
        } catch (i) {
            console.log(i)
        }
    }
}

function essentialFreeShippingInitSlider(e, t) {
    let r = document.getElementById(`essential_product_slider_${e.id}`),
        i = window.location && window.location.pathname.includes("/cart");
}

function essentialFreeShippingGetVariant(e, t) {
    let r = null;
    t.variants.find(i => {
        let a = e.selectedProducts.find(e => {
                let r = e.id.split("/"),
                    i = parseInt(r[r.length - 1]);
                return t.id === i
            }),
            o = a.variants[0].id.split("/"),
            n = parseInt(o[o.length - 1]);
        i.id === n && (r = i.id)
    });
    let i = t.variants.find(e => e.id === r);
    return i
}
async function essentialFreeShippingFetchProductRecommendations(e) {
    if (e) {
        let t = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${e}&limit=4&intent=related`).then(e => e.json()).then(e => e);
        return t
    }
}! function() {
    let e = null;
    async function t() {
        return true;
    }

    function r(e, t) {
        let r = document.getElementsByTagName("head")[0],
            i = document.createElement("style");
        i.setAttribute("type", "text/css"), i.setAttribute("data-id", t), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e)), r.appendChild(i)
    }

    function i(e) {
        return "" !== e.font && e.font ? `font-family: ${e.font};
` : ""
    }

    function a(e, t, r = !1, i) {
        let a, o, n;
        if (i) {
            let p = t.variants[0].id.split("/"),
                s = p[p.length - 1];
            a = {
                id: s
            }, o = t.image, n = 100 * t.price
        } else o = (a = r ? t.variants.find(e => e.available) : essentialFreeShippingGetVariant(e, t))?.featured_image?.src || t.featured_image, n = a && a.price ? a.price : t.price;
        let l = window.Shopify.routes.root || "/",
            d = document.createElement("div");
        d.className = `free_shipping_card_product_${e.id}`, "cart-page" === e.type && (d.className += " cart_page");
        let c = document.createElement("img");
        if (o) {
            let u = o.split(".png").length > 2,
                h = o.split(".jpg").length > 2,
                g = o.split(".webp").length > 1;
            c.className = `free_shipping_card_product_image_${e.id}`, "moki-store-27.myshopify.com" === Shopify.shop || "callistowatches.myshopify.com" === Shopify.shop || "bluefire-fitness-6890.myshopify.com" === Shopify.shop || "mimmo-489.myshopify.com" === Shopify.shop || "0aeed7.myshopify.com" === Shopify.shop || "94ddf0.myshopify.com" === Shopify.shop || g || u || h ? c.setAttribute("src", o) : c.setAttribute("src", o.replace(".jpg", "_120x.jpg").replace(".png", "_120x.png")), c.setAttribute("alt", t.title), c.setAttribute("onclick", `location.href = "${l}products/${t.handle}"`)
        }
        d.append(c);
        let f = document.createElement("div");
        f.className = `free_shipping_card_product_meta_${e.id}`;
        let m = document.createElement("div");
        m.className = `free_shipping_card_product_title_${e.id}`, m.textContent += t.title, m.setAttribute("onclick", `location.href = "${l}products/${t.handle}"`);
        let y = document.createElement("div");
        y.className = `free_shipping_card_product_price_${e.id}`;
        let $ = moneyFormatEssentialApps("${{amount_no_decimals}}", n / 100);
        y.textContent += $;
        let b = document.createElement("a");
        return b.className = `free_shipping_card_product_cta_${e.id}`, b.textContent += e.buttonText, "view-product" === e.CTAType ? b.setAttribute("href", `${l}products/${t.handle}`) : a &&  f.append(m), f.append(y), d.append(f), d.append(b), d
    }
    let o = (e, t, r, i) => {


        let o = `<div id="essential_product_slider_${e.id}" class="essential_product_slider_glide">
      <div class="essential_product_slider_glide__track" data-glide-el="track">
        <ul class="essential_product_slider_glide__slides"></ul>
      </div>
      <div class="essential_product_slider_glide__arrows">
      <div class="essential_product_slider_glide__arrow essential_product_slider_glide__arrow--left" data-glide-dir="<"></div>
        <div class="essential_product_slider_glide__arrow essential_product_slider_glide__arrow--right" data-glide-dir=">"></div>
        </div>
      </div>`,
            n = document.createElement("div");
        n.innerHTML = o;
        let p = n.getElementsByClassName("essential_product_slider_glide__slides")[0],
            s = n.getElementsByClassName("essential_product_slider_glide__arrow--left")[0],
            l = n.getElementsByClassName("essential_product_slider_glide__arrow--right")[0];
     return n;
    };
    async function n() {
        window.freeShippingBarConfigs.threshold = !0;
        let e = window.Shopify.routes.root || "/";
        return fetch(e + "cart.js").then(e => e.json()).then(e => (setTimeout(() => {
            window.freeShippingBarConfigs.threshold = !1
        }, 300), e.items && e.items.length > 0) ? (window.essentialOrderValueBoosterMeta.cartItems = e.items, e) : (window.essentialOrderValueBoosterMeta.cartItems = [], e))
    }
    async function p(e, t, p, s) {
        let l = window.Shopify.currency.active || "",
            d = e.currency || "",
            c = "product-page" === e.type || p ? 1 : 3,
            u = e.upsellType || "",
            h = [],
            g, f = [],
            m = !1,
            y = null;

        let S = SELECTED_PRODUCTS.filter(t => {
            let r = e.selectedProducts.find(e => {
                if ("glapru-amsterdam.myshopify.com" !== Shopify.shop && "vecchio-borgo-tartufi-funghi.myshopify.com" !== Shopify.shop) return e.handle === t.handle;
                {
                    let r = e.id.split("/").pop();
                    return r == t.id
                }
            });
          console.log(r);
            return r
        });
        if (("products" === u || "" === u && S && S.length > 0) && (h = S.filter(e => {
                let t = window.essentialOrderValueBoosterMeta.cartItems.find(t => "glapru-amsterdam.myshopify.com" === Shopify.shop || "vecchio-borgo-tartufi-funghi.myshopify.com" === Shopify.shop ? t.product_id == e.id : t.handle === e.handle);
                return !t
            }).filter(t => {
                let r = essentialFreeShippingGetVariant(e, t);
                return !r || r.available
            }).filter(e => !CURRENT_PRODUCT || ("glapru-amsterdam.myshopify.com" === Shopify.shop || "vecchio-borgo-tartufi-funghi.myshopify.com" === Shopify.shop ? e.id !== CURRENT_PRODUCT.id : e.handle !== CURRENT_PRODUCT.handle))), d && d !== l) return;
        let x = window.location && window.location.pathname.includes("/cart");
        if (e.placement && ("cart-page" === e.type && !x || "product-page" === e.type && "all-products" === e.placement && !window.location.pathname.includes("/products/"))) return;
        let w = document.createElement("div");
        p ? w.className = `free_shipping_card_wrapper_${e.id} placement_side_cart` : w.className = `free_shipping_card free_shipping_card_wrapper_${e.id}`, "cart-page" === e.type && (w.className += " cart_page"), p && (w.style.display = "flex");
        let C = document.createElement("div");
        C.className = `free_shipping_card_title_${e.id} h2`, null !== y ? C.textContent += cardTitleEssentialApps(e, y) : C.textContent += cardTitleEssentialApps(e, s), w.append(C);
        let _ = document.createElement("div");
        _.className = `free_shipping_card_progress_${e.id}`;
        let T = document.createElement("div");
        T.className = `free_shipping_card_progress_bar_${e.id}`, T.style.width = "0", _.append(T), w.append(_);
        let E = document.createElement("div");
        if (E.className = `free_shipping_products_wrapper_${e.id}`, "product-page" === e.type && (E.className += " product_page"), "cart-page" === e.type && (E.className += " cart_page"), p && (E.className += " side_cart"), S && S.length > 0 && "thumbprint-soap.myshopify.com" !== Shopify.shop) {
            let v = h;
            if (v.length > c) {
                E.className += " upsell_products";
                let N = o(e, v);
                m = !0, E.append(N)
            } else v.length > 0 && (p && v[0] && (v = Array(v[0])), v.forEach(t => {
                let r = a(e, t);
                E.append(r)
            }));
            w.append(E)
        } else if (f && f.length > 0) {
            if (E.className += " upsell_products", f.length > 1) {
                let A = o(e, f, !0);
                m = !0, E.append(A)
            } else {
                let B = a(e, f[0], !0);
                E.append(B)
            }
            w.append(E)
        } else if (e.selectedProducts && e.selectedProducts.length > 0) {
            let P = e.selectedProducts;
            if (p && e.selectedProducts && (P = Array(e.selectedProducts[0])), P.length > c) {
                E.className += " upsell_products";
                let R = o(e, P, !1, !0);
                m = !0, E.append(R)
            } else P.forEach(t => {
                let r = a(e, t, !1, !0);
                E.append(r)
            });
            w.append(E)
        } else w.className += " no_products";
        if (! function e(t) {
                let a = t.style,
                    o = document.querySelector(`[data-id="${t.id}"]`);
                if (o) return;
                let n = "gradientBackground" === a.backgroundType ? `linear-gradient(${a.gradientTurn}deg, ${a.gradientStart}, ${a.gradientEnd})` : a.singleColor,
                    p = `
          .free_shipping_card_wrapper_${t.id} {
            display: none;
            flex-flow: column;
            ${i(a)}background: ${n};
            margin-top: ${a.outsideTopSpacing}px;
            margin-bottom: ${a.outsideBottomSpacing}px;
            padding: 0 16px;
            padding-top: ${a.insideTopSpacing}px;
            padding-bottom: ${a.insideBottomSpacing}px;
            border-radius: ${a.borderRadius}px;
            border: ${a.borderColor} solid ${a.borderSize}px;
            text-align: center;
            flex: auto;
            align-items: center;
          }

          .free_shipping_card_wrapper_${t.id}.placement_side_cart {
            flex: none;
          }

          .free_shipping_card_wrapper_${t.id}.placement_side_cart:nth-child(2) {
            display: none !important;
          }

          .free_shipping_card_wrapper_${t.id}.cart_page {
            width: 100%;
          }
  
          .free_shipping_card_title_${t.id}.h2 {
              ${i(a)}font-weight: bold;
              font-size: ${a.titleSize}px;
              /*color: ${a.titleColor};*/
              margin: 0;
              padding: 0;
              line-height: 1.5;
              letter-spacing: normal;
              text-transform: none;
              text-align: center;
          }
          
          .free_shipping_card_progress_${t.id} {
            position: relative;
            max-width: 620px;
            margin-left: auto;
            margin-right: auto;
            margin-top: 10px;
            width: 100%;
            height: 8px;
            background: ${a.progressBackgroundColor};
            border-radius: ${a.progressBorderRadius}px;
          }

          .no_products .free_shipping_card_progress_${t.id} {
            margin-bottom: 6px;
          }

          .free_shipping_card_progress_bar_${t.id} {
            position: absolute;
            left: 0px;
            display: block !important;
            height: 8px;
            background: ${a.progressBarBackgroundColor};
            transition: width 2s;
            border-radius: ${a.progressBorderRadius}px;
          }

          .free_shipping_products_wrapper_${t.id}.product_page {
            width:100%;
            position: relative;
          }

          .free_shipping_products_wrapper_${t.id}.cart_page {
            display: flex;
            width: 100%;
            padding: 0px;
            margin-top: 18px;
            justify-content: center;
            flex-wrap: nowrap;
            position: relative;
          }

          .free_shipping_products_wrapper_${t.id}.upsell_products {
            margin-top: 18px;
            max-width: 1040px;
            display: block;
            position: relative;
          }

          @media(max-width: 1260px) {
            .free_shipping_products_wrapper_${t.id}.cart_page > div:nth-child(3) {
               display: none;
            }
          }

          @media(max-width: 750px) {
            .free_shipping_products_wrapper_${t.id}.cart_page > div:nth-child(2) {
               display: none;
            }
          }

          .free_shipping_card_product_${t.id} {
            display: flex;
            padding-top: 18px;
            width: 100%;
            max-width: 620px;
            margin: 0 auto;
            min-width: 0;
            justify-content: center;
            align-items: center;
          }

          .free_shipping_card_product_${t.id}.cart_page {
            padding: 4px 20px;
            border-radius: 8px;
            max-width: 420px;
          }

          .free_shipping_card_product_image_${t.id} {
            width: 44px;
            height: 44px;
            flex-shrink: 0;
            object-fit: cover;
            cursor: pointer;
            border-radius: 4px;
            overflow: hidden;
          }

          .free_shipping_card_product_meta_${t.id} {
            display: block;
            text-align: left;
            height: 100%;
            padding: 0 8px;
            width: 100%;
            min-width: 0;
          }

          .free_shipping_card_product_title_${t.id} {
            font-size: ${a.productTitleSize}px;
          /*  color: ${a.productTitleColor};*/
            white-space: nowrap;
            overflow: hidden;
            cursor: pointer;
            text-overflow: ellipsis;
            line-height: 1.5;
          }

          .free_shipping_card_product_price_${t.id} {
            font-size: ${a.productPriceSize}px;
          /*  color: ${a.productPriceColor};*/
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 1.5;
          }

          .free_shipping_card_product_cta_${t.id} {
            display: block;
            background-color: transparent;
            cursor: pointer !important;
            font-size: ${a.buttonTextSize}px;
          /*  color: ${a.buttonTextColor};*/
            border: 1px solid ${a.buttonBorderColor};
            border-radius: ${a.buttonRadius}px;
            padding: 8px 12px;
            line-height: 1.2;
            cursor: pointer;
            white-space: nowrap;
            text-decoration: none;
          }

          .cart_page .free_shipping_card_product_${t.id} {
            padding: 4px 22px;
          }

          .side_cart .free_shipping_card_product_${t.id} {
            padding: 4px 0 !important;
          }

          .essential_product_slider_glide .free_shipping_card_product_${t.id} {
            padding: 0;
            width: 100%;
            margin: 0;
            max-width: 100%;
            justify-content: center;
            align-items: center;
          }

          @media(max-width: 420px) {
            .cart_page .free_shipping_card_product_${t.id} {
              padding: 0px;
            }
          }
      `;
                r(p, t.id)
            }(e), t && ("cart-page" === e.type ? (document.querySelector(`.free_shipping_card_wrapper_${e.id}`) || t.prepend(w), window.freeShippingCardInitiated = !1) : t.append(w), m && (x ? setTimeout(() => {
                essentialFreeShippingInitSlider(e)
            }, 300) : essentialFreeShippingInitSlider(e, p))), (1 === s || f) && null === y && (window.freeShippingBarConfigs.threshold = !1), pollCartTotalEssentialApps(), updateTotalOnClick(e), "cart-page" === e.type) {
            if ("pinkblackpalermo.myshopify.com" !== Shopify.shop && "essential-freshness.myshopify.com" !== Shopify.shop) {
                let k = () => {
                    pollCartTotalEssentialApps()
                };
                window.freeShippingBarConfigs.polling || !x || p || (setInterval(k, 2e3), window.freeShippingBarConfigs.polling = !0)
            } else setTimeout(() => {
                updateTotalOnClick(e, !0)
            }, 500)
        }
    }
    let s = (e, t, r) => {
        if (e.type !== t || r && "custom" === e.timerPlacement) return !1;
        if (e.showOnCollections && 0 !== e.showOnCollections.length) {
            let i = decodeURI(window.location.pathname),
                a = e.showOnCollections.find(e => i.includes(`collections/${e.handle}`));
            if (!a) return !1
        }
        return !0
    };

    function l(e, t) {
        if (e.type !== t || window.location && window.location.pathname.includes("/cart") && "top-bar" !== e.type) return !1;
        if (e.showOnProducts && 0 !== e.showOnProducts.length) {
            let r = decodeURI(window.location.pathname),
                i = e.showOnProducts.find(e => r.includes(`products/${e.handle}`));
            if (!i) return !1
        }
        if (e.excludeProducts && 0 !== e.excludeProducts.length) {
            let a = decodeURI(window.location.pathname),
                o = e.excludeProducts.find(e => a.includes(`products/${e.handle}`));
            if (o) return !1
        }
        if (e.excludeProductTags && e.excludeProductTags.length > 0) {
            let n = CURRENT_PRODUCT ? CURRENT_PRODUCT.tags : [],
                p = e.excludeProductTags.some(e => n.includes(e));
            if (p) return !1
        }
        return !0
    }

    function d() {
        let e, t = window.Shopify.routes.root || "/",
            r = document.querySelector(`form[action="${t}cart"]`),
            i = document.querySelectorAll("cart-notification .cart-notification__links"),
            a = document.querySelectorAll(".side-cart"),
            o = document.querySelector(".order-value-booster-side-cart");
        return o ? e = o : i.length > 0 ? e = i[i.length - 1] : r ? e = r : a.length > 0 && (e = a[a.length - 1]), e
    }! function a() {
        let o = window.Shopify.routes.root || "/",
            n = [],
            c, u = document.querySelectorAll("div.order-value-booster-block"),
            h = document.querySelectorAll(`form[action="${o}cart/add"]`),
            g = document.querySelector(".essential-order-value-booster-placement"),
            f = document.querySelector(`form[action="${o}cart"]`),
            m = window.location && window.location.pathname.includes("/cart");
        if (m && f) {
            let y = document.querySelectorAll(`form[action="${o}cart"]`);
            c = y[y.length - 1]
        }
        let $ = window.location && window.location.pathname.includes("/products/");
        u && u.length > 0 && (n = Array.from(u).filter(e => e && "" !== e.getAttribute("id"))), t().then(t => {


          t = window.essentialOrderValueBoosterConfigs;

          
            if (t && !Array.isArray(t) || 0 === t.length) return null;
            let a = t.reduce((e, t) => t.showInCountries && t.showInCountries.length ? [...e, ...t.showInCountries] : e, []),
                o = t.find(e => e.locationType && "on-countries" === e.locationType),
                u = t.filter(t => {
                    if (!o || !(a.length > 0)) return t;
                    if ("on-countries" === t.locationType) {
                        if (!e) return;
                        return t.showInCountries.includes(e)
                    }
                    if (!a.includes(e)) return t
                });
            u.forEach(e => {
                if (e.translations && e.translations.length > 0) {
                    let t = e.translations.find(e => e.locale === Shopify?.locale);
                    t && Object.assign(e, t)
                }
            }), window.freeShippingBarConfigs = u;
            let f = u.filter(e => "top-bar" === e.type);
            f.forEach(e => {
                e && l(e, "top-bar") && s(e, "top-bar") && function e(t, a) {
                    let o = window.Shopify.currency.active || "",
                        n = t.currency || "";
                    if (n && n !== o) return;
                    let p = document.querySelector(".essential_free_shipping_bar_wrapper");
                    if (p) return;
                    if (t.placement) {
                        let s = window.location.pathname;
                        if ("home-page" === t.placement && "/" !== s || "all-products" === t.placement && !window.location.pathname.includes("/products/") || "all-collections" === t.placement && !window.location.pathname.includes("/collections/")) return
                    }
                    let l = document.createElement("div");
                    l.className = `essential_free_shipping_bar_wrapper free_shipping_bar_wrapper_${t.id}`;
                    try {
                        let d = window.localStorage.getItem("freeShippingBarClosed");
                        if ((d = JSON.parse(d)) && d.id === t.id && d.updatedAt === t.updatedAt && d.value) return
                    } catch (c) {
                        console.log(c)
                    }
                    "top-page" === t.style.position && t.style.stickyBar && (l.className += " top_page"), "bottom-page" === t.style.position && (l.className += " bottom_page");
                    let u = document.createElement("div");
                    u.className += `free_shipping_bar_title_${t.id} h2`, u.textContent += cardTitleEssentialApps(t);
                    let h = document.createElement("div");
                    h.append(u);
                    let g = document.createElement("button");
                    g.className = `free_shipping_bar_close_button_${t.id}`, g.setAttribute("onclick", `essentialCloseFreeShippingBar("${t.id}", "${t.updatedAt}")`), g.append(function e(t) {
                            let r = document.createElementNS("http://www.w3.org/2000/svg", "svg"),
                                i = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            return r.setAttribute("width", 12), r.setAttribute("height", 12), r.setAttribute("fill", "none"), i.setAttribute("d", "m7.414 6 4.293-4.293A.999.999 0 1 0 10.293.293L6 4.586 1.707.293A.999.999 0 1 0 .293 1.707L4.586 6 .293 10.293a.999.999 0 1 0 1.414 1.414L6 7.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L7.414 6Z"), i.setAttribute("fill", t), r.append(i), r
                        }(t.style.closeIconColor)), l.append(h), t.closeButton && l.append(g),
                        function e(t) {
                            let a = t.style,
                                o = "gradientBackground" === a.backgroundType ? `linear-gradient(${a.gradientTurn}deg, ${a.gradientStart}, ${a.gradientEnd})` : a.singleColor,
                                n = `
        .free_shipping_bar_wrapper_${t.id} {
          position: relative;
          ${i(a)}background: ${o};
          z-index: 100;
          display: none;
          width: 100%;
          flex-wrap: wrap;
          ${"seperate-centered"===a.announcementBarStyle?`flex-flow: column;
              justify-items: center;`:""}

          align-items: center;
          justify-content: center;
          padding: 10px;
          column-gap: 26px;
          row-gap: 10px;
          border-bottom: ${a.borderColor} solid ${a.borderSize}px;
        }

        .free_shipping_bar_wrapper_${t.id}.top_page {
          position: sticky; 
          top: 0;
        }

        .free_shipping_bar_wrapper_${t.id}.bottom_page {
          bottom: 0; 
          left: 0;
          position: fixed;
          width: 100%;
          border-bottom: none;
          border-top: ${a.borderColor} solid ${a.borderSize}px;
        }
        
        .free_shipping_bar_title_${t.id}.h2 {
            ${i(a)}font-weight: bold;
            font-size: ${a.titleSize}px;
           /* color: ${a.titleColor};*/
            margin: 0;
            padding: 0;
            line-height: 1.2;
            letter-spacing: normal;
            text-transform: none;
            text-align: center;
        }
    
        .free_shipping_bar_close_button_${t.id} {
          position: absolute;
          display: block;
          border: none;
          background: none;
          padding: 6px;
          cursor: pointer;
          top: 50%;
          right: 10px;
          transform: translate(0, -50%);
        }

        .free_shipping_bar_close_button_${t.id} svg {
          width: 12px;
          height: 12px;
          display: block;
        }

        @media (max-width: 430px) {
          .free_shipping_bar_wrapper_${t.id} {
            justify-items: center;
            text-align: center;
            padding: 10px 15px;
          }

          .free_shipping_bar_close_button_${t.id} {
            position: absolute;
            padding: 0;
            transform: none;
            top: 5px;
            right: 5px;
          }

          .free_shipping_bar_title_${t.id} {
              text-align: center;
          }
        }
    `;
                            r(n, t.id)
                        }(t);
                    let f = document.querySelector(".essential-free-shipping-bar");
                    f ? f.append(l) : document.querySelector("body").prepend(l), pollCartTotalEssentialApps(), updateTotalOnClick(t);
                    let m = window.location && window.location.pathname.includes("/cart");
                    if (m) {
                        let y = () => {
                            pollCartTotalEssentialApps()
                        };
                        !window.freeShippingBarConfigs.polling && m && (setInterval(y, 2e3), window.freeShippingBarConfigs.polling = !0)
                    }
                }(e)
            });
            let y;
            y = g || h[h.length - 1], u.forEach(e => {
                l(e, "product-page") && $ && y && "custom" !== e.placement && 0 === n.length && p(e, y)
            }), n.forEach(e => {
                let t = e.getAttribute("id"),
                    r = u.find(e => e.id === t);
                r && l(r, "product-page") && e && p(r, e)
            });
            let b = window.Shopify.currency.active || "";
            if (d() && !m) {
                let S = d(),
                    x = u.find(e => {
                        let t = e.currency || "";
                        return "cart-page" === e.type && ("" === t || t === b)
                    });
                if (x) {
                    "frequently-bought" === x.upsellType ? window.freeShippingCardInitiated = !0 : window.freeShippingCardInitiated = !1, p(x, S, !0);
                    let w = new MutationObserver(e => {
                        if (e && e[0] && e[0].removedNodes && e[0].removedNodes.length && "cart-page-inline-timer h2" === e[0].removedNodes[0].className) return;
                        let t = document.querySelector(`.free_shipping_card_wrapper_${x.id}`),
                            r = d();
                        window.freeShippingCardInitiated || (t ? pollCartTotalEssentialApps() : p(x, r, !0, 1))
                    });
                    if (!window.freeShippingBarConfigs.observer && S) {
                        let C;
                        C = S.parentNode.parentNode.parentNode && "BODY" !== S.parentNode.parentNode.parentNode.tagName && "HTML" !== S.parentNode.parentNode.parentNode.tagName ? S.parentNode.parentNode.parentNode : S.parentNode.parentNode && "BODY" !== S.parentNode.parentNode.tagName && "HTML" !== S.parentNode.parentNode.tagName ? S.parentNode.parentNode : S.parentNode, w.observe(C, {
                            childList: !0,
                            subtree: !0
                        }), window.freeShippingBarConfigs.observer = !0
                    }
                }
            }
            if (m) {
                if (0 === n.length) {
                    let _ = u.find(e => {
                        let t = e.currency || "";
                        return "cart-page" === e.type && ("" === t || t === b)
                    });
                    _ && c && p(_, c.parentNode)
                } else n.forEach(e => {
                    let t = e.getAttribute("id"),
                        r = u.find(e => e.id === t);
                    r && e && p(r, e)
                })
            }
        })
    }()
}();